module.exports = __webpack_public_path__ + "static/media/icon-close.54e63c9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-close.svg
// module id = 107
// module chunks = 0 1 2